import styled from 'styled-components'
import { HeadLine1 } from '../../components/typography/styled'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  padding: 10px 30px;
`
export const NavWrapper = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-top:40px;
  margin-bottom:20px;
  &>div{
    position: absolute;
    bottom:-1px;
    padding-left:30px;
    left:0px;
  }
`
export const AlertsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  padding: 10px 30px;
`